import { handleReceiveMessage } from "./receive.calendar";
import { handleSendMessage } from "./send.calendar";

window.addEventListener("messageFromUsToParent", handleSendMessage, false);

window.addEventListener("message", handleReceiveMessage, false);

let parentContainer = {};
